import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, catchError, of } from 'rxjs';
import { ApiService } from '@core/services/api';

@Injectable({ providedIn: 'root' })
export class SupportBadgeService {
  private readonly api = inject(ApiService);
  private readonly count = new BehaviorSubject(0);
  private readonly novidades = new BehaviorSubject(0);

  readonly count$ = this.count.asObservable();

  /**
   * Versões publicadas depois da última visita a Novidades (painel "Ajuda e
   * suporte", spec §6.1). Mesmo padrão de `count$`: nunca propaga falha,
   * volta a 0.
   */
  readonly novidades$ = this.novidades.asObservable();

  refresh(): void {
    this.api.support.unreadCount()
      .pipe(catchError(() => of({ data: { count: 0 } })))
      .subscribe(response => this.count.next(response.data.count));

    this.api.support.releasesUnseenCount()
      .pipe(catchError(() => of({ data: { count: 0 } })))
      .subscribe(response => this.novidades.next(response.data.count));
  }
}
